export default "__VITE_ASSET__CWQ6g4kV__"